module.exports = __webpack_public_path__ + "static/img/one-title.34c4367.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/one-title.png
// module id = 71
// module chunks = 1